import { Message } from '@/_types/models/conversations';

export const getStillEditable = (message: Message, currentTime: number) => {
  // If the message is scheduled, it is still editable if the scheduled time is in the future
  // If the message is not scheduled, it is still editable if it was created in the last 30 seconds
  return (
    (Boolean(message?.scheduled) &&
      message?.scheduled_time &&
      new Date(message.scheduled_time) > new Date(currentTime)) ||
    (Boolean(message?.created_at) &&
      new Date(message.created_at) > new Date(currentTime - 30000))
  );
};
